export default __webpack_public_path__ + "static/media/back-arrow.b0164a0a.svg";